// extracted by css-extract-rspack-plugin
export default {"list":"ForYouSubSection-module__list__suKwZ","heading":"ForYouSubSection-module__heading__eVZQi"};